import { useQueryClient } from "@tanstack/react-query";

import { getAuthControllerGetCurrentUserQueryKey } from "@/lib/lutely-api/gen/auth/auth";
import { useProfileControllerMarkAudiolabTourSeen } from "@/lib/lutely-api/gen/profile/profile";

/**
 * Persists the one-time "artist has seen the Audiolab tour" flag on the user
 * profile, then refetches the current user so the tour never re-triggers.
 * Mirrors useOnboardingBannerMutations.
 */
export function useMarkAudiolabTourSeen() {
  const queryClient = useQueryClient();

  return useProfileControllerMarkAudiolabTourSeen({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getAuthControllerGetCurrentUserQueryKey(),
        });
      },
    },
  });
}
